export interface SelectOption {
  id: number | string;
  info: SelectOptionData;
  checked?: boolean;
  disabled?: boolean;
  disabledText?: string;
}

export type SelectOptionValue = (string | number)[] | undefined;

export interface SelectOptionData {
  id?: number | string;
  title: string;
  version?: string;
  description?: string;
  image?: string;
}

export enum SelectVariationEnum {
  Small = 'small',
  Large = 'large',
  Default = 'default',
}

export enum SelectOrientationEnum {
  Top = 'top',
  Bottom = 'bottom',
}
